import Dropdown from 'react-bootstrap/Dropdown';
import React from 'react';
import GridLogo from './GridLogo';

/**
 * Navigation Dropdown Component.
 * Displays navigation icon which opens a dropdown with links to other dashboards in the project.
 *
 * ```jsx
 * <NavigationDropdown />
 * ```
 */
function NavigationDropdown() {

  return (
    <Dropdown className="NavigationDropdown" >

      <Dropdown.Toggle
        id="nav-dropdown"
        variant="default"
        className="dropdown-icon-only"
        aria-label="WISQARS Site Navigation Dropdown">
        <GridLogo/>
      </Dropdown.Toggle>

      <Dropdown.Menu role="navigation" align="right" renderOnMount={true}>

        <Dropdown.Header aria-level="6">
          Fatal Injury and Violence Data
        </Dropdown.Header>

        <Dropdown.Item href="/explore">
          Fatal Injury Data Explore
        </Dropdown.Item>

        <Dropdown.Item href="/compare">
          Fatal Injury Data Compare Cause
        </Dropdown.Item>

        <Dropdown.Item href="/comparestate">
          Fatal Injury Data Compare State
        </Dropdown.Item>

        <Dropdown.Item href="/reports">
          Fatal Injury Reports
        </Dropdown.Item>

        <Dropdown.Item href="/lcd">
          Leading Causes of Death
        </Dropdown.Item>

        <Dropdown.Item href="/nvdrs">
          National Violent Death Reporting System
        </Dropdown.Item>

        <Dropdown.Item href="/../fatal-injury-trends">
          Provisional Data
        </Dropdown.Item>

        <Dropdown.Divider />

        <Dropdown.Header aria-level="6">
          Nonfatal Injury Data
        </Dropdown.Header>

        <Dropdown.Item href="/explore/?o=NFI&y1=2023&y2=2023&i=0&m=3000&d=0&s=0&r=0&e=0&a=ALL&a1=0&a2=199&g1=0&g2=199">
          Nonfatal Injury Data Visualization
        </Dropdown.Item>

        {/* eslint-disable-next-line max-len */}
        <Dropdown.Item href="/reports/?o=NFI&y1=2023&y2=2023&d=0&i=0&m=3000&g=00&s=0&r=0&ry=2&e=0&a=ALL&g1=0&g2=199&a1=0&a2=199&r1=INTENT&r2=NONE&r3=NONE&r4=NONE&adv=true">
          Nonfatal Injury Reports
        </Dropdown.Item>

        <Dropdown.Item href="/lcnf">
          Leading Causes of Nonfatal Injury
        </Dropdown.Item>

        <Dropdown.Divider />

        <Dropdown.Header aria-level="6">
          Cost of Injury
        </Dropdown.Header>

        <Dropdown.Item href="/cost">
          Cost of Injury
        </Dropdown.Item>

        <Dropdown.Item href="/opioid">
          Cost of Opioid Use Disorder
        </Dropdown.Item>

        <Dropdown.Divider />

        <Dropdown.Header aria-level="6">
          Community Health Factors
        </Dropdown.Header>

        <Dropdown.Item href="/communityhealthfactors">
          Community Health Factors
        </Dropdown.Item>

        <Dropdown.Divider />

        <Dropdown.Header aria-level="6">
          Infographics
        </Dropdown.Header>

        <Dropdown.Item href="/infographics">
          Infographics Tool
        </Dropdown.Item>

        <Dropdown.Divider />

        <Dropdown.Header aria-level="6">
          Help Using Injury Data
        </Dropdown.Header>

        <Dropdown.Item href="/about">
          Help Using Injury Data
        </Dropdown.Item>

      </Dropdown.Menu>

    </Dropdown>
  );
}

export default NavigationDropdown;
